import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { CashFlowStatementSchema } from "../../types"

type CashFlowStatementType = {
  date_start: string
  location_id: string
}
export function useCashFlowStatementList(params?: CashFlowStatementType) {
  const api = useApi()
  const [data, setData] = useState<CashFlowStatementSchema | null>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  const refetch = (params: CashFlowStatementType): void => {
    setLoading(true)
    const isLocation = params.location_id !== "" ? params.location_id : null

    api.get("/dashboard/cash-flow-statement/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: CashFlowStatementSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    const isLocation = params?.location_id !== "" ? params?.location_id : null
    setLoading(true)
  
    api.get("/dashboard/cash-flow-statement/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: CashFlowStatementSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { data, isLoading, refetch }
}